export default __webpack_public_path__ + "static/media/logo-pajakku.82a351a2.svg";